import React from 'react';
const CancellationPolicy = () => {
  return <div className="bg-gray-50 min-h-screen" data-id="element-304">
      <div className="bg-[#1a3a6c] text-white py-16" data-id="element-305">
        <div className="container mx-auto px-4 text-center" data-id="element-306">
          <h1 className="text-4xl font-bold mb-6" data-id="element-307">Cancellation Policy</h1>
          <p className="text-xl max-w-3xl mx-auto" data-id="element-308">
            Information about our cancellation procedures and exclusions.
          </p>
        </div>
      </div>
      <div className="container mx-auto px-4 py-16" data-id="element-309">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8" data-id="element-310">
          <h2 className="text-2xl font-bold text-[#1a3a6c] mb-6" data-id="element-311">
            Cancellation Policy & Exclusions
          </h2>
          <p className="text-gray-700 mb-6" data-id="element-312">
            At Opticore, your satisfaction with our service plans is our
            priority. We understand that circumstances can change, so we offer a
            simple and transparent cancellation process to give you peace of
            mind.
          </p>
          <div className="space-y-6" data-id="element-313">
            <div className="border-b pb-6" data-id="element-314">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-315">
                Cancellation Within 14 Days
              </h3>
              <p className="text-gray-700" data-id="element-316">
                You have the right to cancel your service plan within 14 days of
                purchase. If you cancel within this period, you'll receive a
                full refund—no questions asked. This cooling-off period lets you
                review your plan to ensure it meets your needs.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-317">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-318">
                Cancellation After 14 Days and Within 28 Days
              </h3>
              <p className="text-gray-700" data-id="element-319">
                If you decide to cancel after the initial 14-day period but
                within 28 days from purchase, you may be eligible for a partial
                refund. This refund is granted at Opticore's discretion,
                considering any services or repairs already provided under your
                plan.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-320">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-321">
                No Cancellations or Refunds After 28 Days
              </h3>
              <p className="text-gray-700" data-id="element-322">
                Cancellations and refunds cannot be processed after 28 days from
                the purchase date. Please review your plan carefully and contact
                us promptly if you have any concerns or need assistance.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-323">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-324">
                How to Cancel Your Service Plan
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-325">
                To cancel your plan, please contact our customer support team
                using the following:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-326">
                <li data-id="element-327">Phone: 0800 055 4969</li>
                <li data-id="element-328">Email: 23tata0716@gmail.com</li>
              </ul>
              <p className="text-gray-700" data-id="element-329">
                Once we receive your cancellation request, we'll review your
                case promptly. If eligible, your refund will be processed
                quickly, and you'll receive confirmation when your cancellation
                and refund are complete.
              </p>
            </div>
            <div className="border-b pb-6" data-id="element-330">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-331">
                Refund Processing
              </h3>
              <p className="text-gray-700" data-id="element-332">
                All refunds are made to the original payment method used at
                purchase. For security reasons, we don't process refunds to
                alternative accounts or payment methods.
              </p>
            </div>
            <div data-id="element-333">
              <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-334">
                Plan Exclusions and Coverage Limits
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-335">
                To maintain fairness and service quality, the following are
                excluded from coverage under your Opticore plan:
              </p>
              <ul className="list-disc pl-6 text-gray-700 mb-4" data-id="element-336">
                <li data-id="element-337">
                  <span className="font-medium" data-id="element-338">Pre-existing Faults:</span>{' '}
                  Faults or damage present before your plan started are not
                  covered.
                </li>
                <li data-id="element-339">
                  <span className="font-medium" data-id="element-340">Misuse or Neglect:</span> Damage
                  caused by improper use, neglect, accidents, or unauthorized
                  repairs is excluded.
                </li>
                <li data-id="element-341">
                  <span className="font-medium" data-id="element-342">Non-standard Repairs:</span>{' '}
                  Repairs beyond normal appliance operation or servicing,
                  including modifications or alterations, are excluded.
                </li>
                <li data-id="element-343">
                  <span className="font-medium" data-id="element-344">
                    Illegal or Fraudulent Use:
                  </span>{' '}
                  Any fraudulent or illegal use of our services will result in
                  immediate plan cancellation without refund.
                </li>
                <li data-id="element-345">
                  <span className="font-medium" data-id="element-346">
                    Manufacturer's Guidelines:
                  </span>{' '}
                  Appliances not used or maintained as per manufacturer
                  instructions are excluded.
                </li>
              </ul>
              <p className="text-gray-700" data-id="element-347">
                If any of these exclusions apply, your plan may be voided
                immediately, and you'll lose eligibility for repairs or refunds
                under the plan.
              </p>
            </div>
          </div>
          <div className="mt-8 p-6 bg-gray-50 rounded-lg" data-id="element-348">
            <h3 className="text-xl font-bold text-[#1a3a6c] mb-3" data-id="element-349">
              Need Help?
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-350">
              If you have any questions about cancelling your plan or want
              clarification on coverage, please contact our customer service
              team. We're here to support you and ensure you understand your
              options clearly.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-351">
              <a href="tel:08000554969" className="bg-[#3b82f6] text-white py-2 px-6 rounded-md font-medium hover:bg-[#1a3a6c] transition-colors text-center" data-id="element-352">
                Call 0800 055 4969
              </a>
              <a href="mailto:23tata0716@gmail.com" className="bg-white text-[#1a3a6c] py-2 px-6 rounded-md font-medium border border-[#1a3a6c] hover:bg-gray-50 transition-colors text-center" data-id="element-353">
                Email Us
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default CancellationPolicy;